(function () {
'use strict';

angular.module('hyresgastApp').controller('NegotiationTableCtrl', NegotiationTableCtrl);

function NegotiationTableCtrl(
  $location, $routeParams,
  FeatureConfiguration, User) {
  var vm = this;
  vm.FeatureConfiguration = FeatureConfiguration;

  vm.personsColumns = [
    { title: 'Person', column: 'fullName' },
    { title: 'Organisation', column: 'organizationName' },
    { title: 'Gemensamma förhandlingar', column: 'numNegotiations' },
    { title: 'Antal fastigheter', column: 'numProperties' }
  ];

  vm.gotoShow = row => {
    $location.path('/users/' + $routeParams.id + '/negotiator/' + row.userId + '/organization/' + row.organizationId + '/welcome/negotiation-table/negotiator?view=list');
  }
  vm.getContextInfo = row => ({
    title: `Person `+row.fullName,
    link: '/users/' + $routeParams.id + '/negotiator/' + row.userId + '/organization/' + row.organizationId + '/welcome/negotiation-table/negotiator?view=list'
  });

  vm.getData = function () {
    // eslint-disable-next-line no-undef, no-unused-vars
    return new Promise(resolve => {
      User.queryNegotiationTables({})
        .$promise.then(function(data) {
          data.rows.forEach(x => x.fullName = `${x.firstname} ${x.lastname}`);
          resolve(data);
        });
    });
  }
}

})();